import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform, inject } from '@angular/core';

@Pipe({
  name: 'clientPortalOverviewValue',
})
export class ClientPortalOverviewValuePipe implements PipeTransform {
  private readonly datePipe = inject(DatePipe);


  transform(value: any, ...args: any[]): any {
    if (typeof value === 'string') {
      return value;
    }

    return this.datePipe.transform(value, 'MM-dd-yyyy') || '';
  }
}
